import React from 'react';

const PlaceCardSkeleton = () => {
  return (
    <div className="bg-theme-card border border-theme-border rounded-xl overflow-hidden animate-pulse">
      {/* Image skeleton */}
      <div className="aspect-video bg-theme-card-secondary"></div>

      {/* Content skeleton */}
      <div className="p-3">
        {/* Category badge skeleton */}
        <div className="h-5 w-20 bg-theme-card-secondary rounded mb-2"></div>

        {/* Title skeleton */}
        <div className="space-y-2">
          <div className="h-4 bg-theme-card-secondary rounded w-full"></div>
          <div className="h-4 bg-theme-card-secondary rounded w-3/4"></div>
        </div>

        {/* Metro skeleton */}
        <div className="mt-2 h-3 bg-theme-card-secondary rounded w-1/2"></div>
      </div>
    </div>
  );
};

export default PlaceCardSkeleton;
